import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { createProjectPortfolioError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  { portfolio }: Boundaries["editProjectPortfolio"]["request"],
): State {
  const index = state.findIndex((req) => req.portfolio.uuid === portfolio.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          portfolio,
          request: setRequestStateToPending(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          portfolio,
          request: setRequestStateToPending(),
          error: createProjectPortfolioError,
        },
      ];
}

function handleSuccess(
  state: State,
  { portfolio }: Boundaries["editProjectPortfolio"]["success"],
): State {
  const index = state.findIndex((req) => req.portfolio.uuid === portfolio.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          portfolio,
          request: setRequestStateToSuccess(),
          error: createProjectPortfolioError,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          portfolio,
          request: setRequestStateToSuccess(),
          error: createProjectPortfolioError,
        },
      ];
}

function handleFailure(
  state: State,
  { portfolio, error }: Boundaries["editProjectPortfolio"]["failure"],
): State {
  const index = state.findIndex((req) => req.portfolio.uuid === portfolio.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { portfolio, request: setRequestStateToFailure(), error },
        ...state.slice(index + 1),
      ]
    : [...state, { portfolio, request: setRequestStateToFailure(), error }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectPortfolioRequested]: handleRequest,
    [events.editProjectPortfolioSucceeded]: handleSuccess,
    [events.editProjectPortfolioFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
